import { Routes } from '@angular/router';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () => import('./pages/reports-list/reports-list.component').then((m) => m.ReportsListComponent),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.REPORT_VIEW],
			comeback: 'panel',
		},
	},
] as Routes;
